module.exports = __webpack_public_path__ + "static/reporting-cc4bdede491103fd6fdbaeff9031c5f0.png";